import React, { useContext, useEffect } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './Contact.css';

const Contact = () => {
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    if (language === 'ar') {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, [language]);

  const content = {
    ar: {
      bankDetailsTitle: 'تفاصيل الحساب البنكي',
      bankDetails: [
        '1/ رقم حساب (30030616) بنك فيصل الإسلامي - فرع بورتسودان عملة محلية جنيه سوداني ودولار',
        ' IBAN للتحويلات الخارجية بالعملات الأجنبية  ( SD16 0230 0306 160002 ) ',
        '2/ رقم حساب  (1116283) بنك امدرمان الوطني - فرع بورتسودان عملة محلية جنيه سوداني ودولار',
        ' IBAN للتحويلات الخارجية بالعملات الأجنبية  ( SD342111628300001 ) ',
        '3/ رقم حساب  (9581287) بنك الخرطوم - فرع بورتسودان عملة محلية جنيه سوداني ودولار',
        ' IBAN للتحويلات الخارجية بالعملات الأجنبية  ( SD2004095812870002 ) ',

      ],
      title: 'التواصل معنا',
      details: [
        'الهاتف: +249 123017742 | +249 963174603',
        'البريد الإلكتروني: alkhold.org2014@gmail.com',
        'العنوان: شارع إفريقيا، الخرطوم',
      ],
    },
    en: {
      bankDetailsTitle: 'Bank Account Details',
      bankDetails: [
        '* Local Currency Account (SDG): (30030616) Faisal Islamic Bank - Port Sudan Branch',
        '* IBAN for Foreign Currency Transfers (USD): (SD 16 0230 0306 160002) Faisal Islamic Bank',
      ],
      title: 'Contact Us',
      details: [
        'Phone: +249 123017742 | +249 963174603',
        'Email: alkhold.org2014@gmail.com',
        'Address: Africa Street, Khartoum',
      ],
    },
  };

  const langContent = content[language];

  return (
    <div className="contact">
      <h3>{langContent.bankDetailsTitle}</h3>
      <ul className="bank-details">
        {langContent.bankDetails.map((detail, index) => (
          <li key={index}>{detail}</li>
        ))}
      </ul>
      <h2>{langContent.title}</h2>
      <ul className="contact-details">
        {langContent.details.map((detail, index) => (
          <li key={index}>{detail}</li>
        ))}
      </ul>
    </div>
  );
};

export default Contact;
